import { CheckOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { loadFacebookSdk } from 'components/Meta/useMetaSignup';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

const HELP_URL = 'https://br24.bitrix24.com.br/~CRS6d';
// "Saiba mais" da cobranca da API oficial.
const API_COMPARISON_URL = 'https://kory-one-guide.lovable.app/api-oficial-vs-nao-oficial';

const linkTo = (href) => (chunks) =>
	(
		<a href={href} target="_blank" rel="noopener noreferrer">
			{chunks}
		</a>
	);
const helpLink = linkTo(HELP_URL);
const apiComparisonLink = linkTo(API_COMPARISON_URL);

const OPTIONS = [
	{
		api: 'zapi',
		title: 'choice_qr_title',
		bullets: ['choice_qr_b1', 'choice_qr_b2', 'choice_qr_b3', 'choice_qr_b4'],
		highlight: 'choice_qr_highlight',
	},
	{
		api: 'meta',
		title: 'choice_meta_title',
		bullets: ['choice_meta_b1', 'choice_meta_b2', 'choice_meta_b3', 'choice_meta_b4'],
		highlight: 'choice_meta_highlight',
	},
];

export default function ConnectionChoiceScreen({ api, planType, onSelectApi }) {
	// O plano BASIC so inclui numero da API oficial; a conexao direta (Z-API) e do PRO.
	const zapiLocked = planType === 'BASIC';

	// SDK pronto antes do clique em "Continuar configuração": a tela seguinte abre o popup da
	// Meta dentro desse clique, e popup fora de gesto do usuário é bloqueado. Só para quem
	// escolheu a API oficial - quem vai de QR Code não carrega script do Facebook.
	useEffect(() => {
		if (api === 'meta') {
			loadFacebookSdk().catch(() => {});
		}
	}, [api]);

	// O shell comeca em 'zapi'; para o BASIC isso apontaria para a opcao bloqueada.
	useEffect(() => {
		if (zapiLocked && api === 'zapi') {
			onSelectApi('meta');
		}
	}, [zapiLocked, api]);

	return (
		<div className="choice-screen">
			<header className="onboarding-screen-header">
				<h1>
					<FormattedMessage id="choice_title" />
				</h1>
				<p>
					<FormattedMessage id="choice_subtitle" />
				</p>
			</header>
			<div className="choice-options" role="radiogroup">
				{OPTIONS.map((opt) => {
					const locked = zapiLocked && opt.api === 'zapi';
					const select = () => {
						if (!locked) onSelectApi(opt.api);
					};
					return (
						<div
							key={opt.api}
							role="radio"
							aria-checked={api === opt.api}
							aria-disabled={locked}
							tabIndex={locked ? -1 : 0}
							className={`choice-option ${api === opt.api ? 'choice-option-selected' : ''} ${
								locked ? 'choice-option-locked' : ''
							}`}
							onClick={select}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									select();
								}
							}}
						>
							<div className="choice-option-title">
								<FormattedMessage id={opt.title} />
							</div>
							{opt.bullets.map((key) => (
								<div key={key} className="choice-option-item">
									<CheckOutlined />
									<span>
										<FormattedMessage id={key} values={{ link: apiComparisonLink }} />
									</span>
								</div>
							))}
							<div className="choice-option-item choice-option-highlight">
								<CheckOutlined />
								<FormattedMessage id={opt.highlight} />
							</div>
							{locked && (
								<div className="choice-option-upsell" role="note">
									<p>
										<FormattedMessage id="choice_pro_only" />
									</p>
									{/* Destino do upgrade ainda nao definido: so sinaliza que precisa. */}
									<Button type="primary" disabled>
										<FormattedMessage id="choice_upgrade" />
									</Button>
								</div>
							)}
						</div>
					);
				})}
			</div>
			<p className="choice-footer">
				<FormattedMessage id="choice_footer" values={{ link: helpLink }} />
			</p>
		</div>
	);
}
